// Mock data for The Tech Reach

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Talent Solutions', path: '/talent' },
  { label: 'Industries', path: '/industries' },
  { label: 'Careers', path: '/careers' },
  { label: 'Contact', path: '/contact' },
];

export const HERO = {
  eyebrow: 'IT Recruitment • Executive Search • SaaS Solutions',
  title: 'Empowering Businesses with',
  titleAccent: 'Game-Changing Talent',
  subtitle:
    'From IT engineering to executive leadership — we connect ambitious companies with exceptional people. Fast, precise, and built for scale.',
  primaryCta: { label: 'Hire Talent', to: '/contact' },
  secondaryCta: { label: 'Looking for a Job?', to: '/careers' },
  stats: [
    { value: '500+', label: 'Placements Delivered' },
    { value: '15d', label: 'Avg. Time-to-Hire' },
    { value: '95%', label: 'Retention After 1 Year' },
    { value: '48h', label: 'First Qualified Shortlist' },
  ],
};

export const CORE_SERVICES = [
  {
    icon: 'UserSearch',
    title: 'IT Talent Acquisition',
    desc: 'Vetted software, cloud, AI/ML and data engineers matched to your exact stack — contract, C2H, and direct hire.',
  },
  {
    icon: 'Briefcase',
    title: 'Executive Search',
    desc: 'Confidential leadership hiring for CTOs, VP Engineering, Heads of AI, and other mission-critical roles.',
  },
  {
    icon: 'Cloud',
    title: 'SaaS Implementation',
    desc: 'End-to-end configuration, integration and support of enterprise SaaS platforms — done right, first time.',
  },
  {
    icon: 'Layers',
    title: 'Workforce & Staffing',
    desc: 'Scalable workforce solutions across tech, finance and operations — flexible engagement models built for growth.',
  },
  {
    icon: 'Cpu',
    title: 'Technology Consulting',
    desc: 'Architecture, DevOps, cloud engineering and cybersecurity — advisory that turns roadmaps into results.',
  },
  {
    icon: 'Building2',
    title: 'BPO & KPO Services',
    desc: 'Business and knowledge process outsourcing with a US-based delivery hub and global talent bench.',
  },
];

export const TALENT_ROLES = [
  'LLM & Generative AI Engineers',
  'MLOps & AI Platform Engineers',
  'Computer Vision Specialists',
  'Data Pipeline & Data Engineers',
  'Cloud AI Practitioners (AWS / Azure / GCP)',
  'Full-Stack Engineers (React, Node.js)',
  'DevOps & Site Reliability Engineers',
  'Cybersecurity & Compliance Experts',
  'IoT & Embedded Systems Engineers',
  'Product & Engineering Leadership',
];

export const ENGAGEMENT_MODELS = [
  {
    tag: 'Contract',
    title: 'Contract Staffing',
    desc: 'Bring specialised engineers on board for a defined scope. We handle W-2 employment, payroll and compliance end-to-end.',
    perks: ['Rapid deployment in days', 'Compliance & payroll handled', 'Scale up or down flexibly'],
  },
  {
    tag: 'Contract-to-Hire',
    title: 'Contract-to-Hire',
    desc: 'Trial the fit before you commit. Convert your top performers into full-time employees on your terms.',
    perks: ['Try before you hire', 'Reduced hiring risk', 'Structured conversion path'],
  },
  {
    tag: 'Direct Hire',
    title: 'Direct Placement',
    desc: 'Permanent placements for roles that anchor your team. Rigorous vetting, cultural fit, replacement guarantee.',
    perks: ['90-day replacement guarantee', 'Executive & niche roles', 'Confidential search available'],
  },
];

export const PROCESS = [
  {
    step: '01',
    title: 'Scope the Role',
    desc: 'We deep-dive into your stack, team dynamics and the outcomes you are hiring for.',
  },
  {
    step: '02',
    title: 'Source & Screen',
    desc: 'We tap our nationwide network and technically vet every candidate before you see them.',
  },
  {
    step: '03',
    title: 'Interview & Select',
    desc: 'Meet a short list of pre-qualified engineers and choose the one that fits.',
  },
  {
    step: '04',
    title: 'Onboard & Support',
    desc: 'We handle the paperwork and stay close through the entire engagement.',
  },
];

export const INDUSTRIES = [
  { name: 'Technology', icon: 'Cpu', desc: 'SaaS, platforms, deep-tech and AI-native product companies.' },
  { name: 'Financial Services', icon: 'Landmark', desc: 'Banks, fintech, capital markets and payments infrastructure.' },
  { name: 'Healthcare', icon: 'HeartPulse', desc: 'HealthTech, payers, providers, life sciences and digital health.' },
  { name: 'Insurance', icon: 'ShieldCheck', desc: 'Carriers, InsurTech, claims automation and underwriting analytics.' },
  { name: 'Communications', icon: 'Radio', desc: 'Telecom, media, streaming and modern communication platforms.' },
  { name: 'Retail & eCommerce', icon: 'ShoppingBag', desc: 'Omnichannel commerce, marketplaces and consumer platforms.' },
];

export const CLIENT_LOGOS = ['Google', 'Microsoft', 'Dropbox', 'HubSpot', 'Zoom', 'Adobe', 'Stripe', 'Salesforce'];

export const TESTIMONIALS = [
  {
    quote:
      'The Tech Reach delivered senior ML engineers in under two weeks — the shortlist was on point and the placements are still with us a year later.',
    author: 'Priya Nair',
    role: 'VP Engineering, FinTech Scale-up',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=120&h=120',
  },
  {
    quote:
      'From CTO search to a whole platform team, they became our extended talent function. Precise, fast and refreshingly consultative.',
    author: 'Marcus Bennett',
    role: 'Founder & CEO, HealthTech Startup',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=120&h=120',
  },
  {
    quote:
      'What sets them apart is the quality of screening. Every candidate we interviewed could have done the job — we just picked the best fit.',
    author: 'Jane Smith',
    role: 'Head of Talent, SaaS Enterprise',
    avatar: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=120&h=120',
  },
];

export const JOBS = [
  { title: 'Senior LLM Engineer', location: 'Remote (US)', type: 'Contract', tags: ['Python', 'LangChain', 'AWS'] },
  { title: 'MLOps Architect', location: 'Frisco, TX', type: 'Direct Hire', tags: ['Kubernetes', 'MLflow', 'GCP'] },
  { title: 'Full-Stack Engineer', location: 'Remote (US)', type: 'C2H', tags: ['React', 'Node.js', 'PostgreSQL'] },
  { title: 'Cloud Security Lead', location: 'New York, NY', type: 'Direct Hire', tags: ['Azure', 'SOC2', 'IAM'] },
  { title: 'Data Platform Engineer', location: 'Remote (US)', type: 'Contract', tags: ['Snowflake', 'dbt', 'Airflow'] },
  { title: 'VP of Engineering', location: 'Austin, TX', type: 'Executive Search', tags: ['Leadership', 'Scale-up'] },
];

export const LOGO_URL = 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=496,fit=crop/AE0aJELQbPfqN1Wb/screenshot-2025-03-03-171049-Aq2q9Rn93Mf1yM9w.png';

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1765539160785-e7953620488f?auto=format&fit=crop&w=1600',
  aboutA: 'https://images.unsplash.com/photo-1615803697515-3cb782c2a65a?auto=format&fit=crop&w=1200',
  aboutB: 'https://images.pexels.com/photos/880989/pexels-photo-880989.jpeg?auto=compress&cs=tinysrgb&w=1200',
  netA: 'https://images.unsplash.com/photo-1647356191320-d7a1f80ca777?auto=format&fit=crop&w=1600',
  netB: 'https://images.unsplash.com/photo-1674027444485-cec3da58eef4?auto=format&fit=crop&w=1600',
  hiringA: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200',
  hiringB: 'https://images.unsplash.com/photo-1759661881353-5b9cc55e1cf4?auto=format&fit=crop&w=1200',
};

export const CONTACT_INFO = {
  phone: '+1 929 709 0448',
  email: 'info@thetechreach.com',
  address: '30 N Gould St Ste R, Sheridan, WY 82801',
  linkedin: 'https://www.linkedin.com/company/the-tech-reachh/',
  twitter: 'https://x.com/The_TechReach',
};
